export default function Footer() {
  return (
    <footer>
      <h3>Mardacannes Residence</h3>
      <p>
        📍 Located in the heart of Mardakan, Absheron – blending modern design
        with nature.
      </p>
      <p>
        🏡 A premium lifestyle community with luxury villas, private pools, and
        exclusive services.
      </p>
      <p>📞 +994 55 123 45 67 | 📧 info@mardacannes.com</p>
      <p>© 2025 Mardacannes Residence. All rights reserved.</p>
    </footer>
  );
}
